package com.milta.feature.ocrscan.domain.usecase

import com.milta.feature.ocrscan.domain.entity.OcrScanResult
import com.milta.feature.ocrscan.domain.repository.OcrScanRepository

/** POST /api/v1/ocr-scans — écran B du mockup. */
class ScanDeliveryPhotoUseCase(private val repository: OcrScanRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String): OcrScanResult =
        repository.scanPhoto(fileBytes, fileName)
}
